import React from "react";

import "./courseRequirements.scss";

const CourseRequirements = () => {
  return (
    <div className="course_requirements" id="course_requirements">
      <div className="course_requirements__inner">
        <div className="course_requirements_title">
          Курсқа қабылдану үшін талапкерге қойылатын критерийлер:
        </div>
        <div className="course_requirements_body">
          * талапкердің жасы 18-45 жас аралығында болуы;
        </div>
        <div className="course_requirements_body">
          * ақпараттық технологиялар пәнінен сауаттылық деңгейі;
        </div>
        <div className="course_requirements_body">
          * математика пәнінен сауаттылық деңгейі.
        </div>

        <div className="course_requirements_footer">
          Қабылдау емтихандарының сипаттамасы:
          <ul>
            <li>Логикалық тестілеу;</li>
            <li>Ағылшын тілін білу;</li>
            <li>Сұхбат.</li>
          </ul>
        </div>

        <div className="course_requirements_title">
          Мақсатты аудитория:
        </div>
        <div className="course_requirements_body">
          * IT саласында жаңа білім аламын деушілер;
        </div>
        <div className="course_requirements_body">
          * біліктілік арттырамын деуші IT мамандар;
        </div>
        <div className="course_requirements_body">
          * біліктілік көтеретін педагог-мамандар.
        </div>
      </div>
    </div>
  );
};

export default CourseRequirements;
